import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LookupService } from 'src/app/share/services/lookup/lookup.service';
import { CommonService } from 'src/app/share/services/common/common.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from 'src/app/share/enums/storage.enum';

@Component({
    selector: 'app-material-group',
    templateUrl: './material-group.component.html',
    styleUrl: './material-group.component.scss',
    standalone: false
})
export class MaterialGroupComponent implements OnInit {
  materialGroupFormGroup !: FormGroup;
  materialGroups   : any[]   = [];
  selfDetails      : any     = null;
  activeCompanyId  : string  = '';
  errorMessage     : string  = '';
  tosterMessage    : string  = '';
  loadRecords      : boolean = false;
  verifyLoader     : boolean = false;
  isPanelOpen      : boolean = false;
  isSuccessToster  : boolean = false;
  isErrorToster    : boolean = false;

  constructor(
    private readonly _fb           : FormBuilder,
    private readonly lookupService : LookupService,
    private readonly storageService: StorageService,
    public readonly commonService  : CommonService
  ) { }

  ngOnInit(): void {
    this.selfDetails = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    this.activeCompanyId = this.selfDetails?.company;
    this.createFormGroup();
    this.getMaterialGroupList();
  }

  createFormGroup() {
    this.materialGroupFormGroup = this._fb.group({
      name        : ['', [Validators.required]],
      materialCode: ['', [Validators.required]]
    });
  }

  getMaterialGroupList() {
    this.loadRecords = true;
    this.lookupService.getMaterialGroups(this.activeCompanyId)?.subscribe({
      next: (res: any) => {
        this.loadRecords = false;
        this.materialGroups = res?.data || [];
      },
      error: (err: any) => {
        this.loadRecords = false;
        this.errorMessageFunction(err?.error?.message);
      }
    });
  }

  openAddPanel() {
    document.body.style.overflow = 'hidden';
    this.errorMessage = '';
    this.materialGroupFormGroup?.reset();
    this.isPanelOpen = true;
  }

  closeAddPanel() {
    document.body.style.overflow = '';
    this.isPanelOpen = false;
    this.verifyLoader = false;
    this.errorMessage = '';
    this.materialGroupFormGroup?.reset();
  }

  onSubmit() {
    if (this.materialGroupFormGroup.invalid) {
      this.materialGroupFormGroup.markAllAsTouched();
      return;
    }
    this.verifyLoader = true;
    this.errorMessage = '';
    this.lookupService.addMaterialGroup(this.activeCompanyId, { ...this.materialGroupFormGroup.value })?.subscribe({
      next: () => {
        this.closeAddPanel();
        this.successMessageFunction('Material Group is added successfully');
      },
      error: (err: any) => {
        this.verifyLoader = false;
        this.errorMessageFunction(err?.error?.message);
      }
    });
  }

  errorMessageFunction(message: any) {
    this.errorMessage = message;
    this.isErrorToster = true;
    this.tosterMessage = message;
  }

  successMessageFunction(message: any) {
    this.isSuccessToster = true;
    this.tosterMessage = message;
    this.getMaterialGroupList();
  }

  closingToster(value: any) {
    this.isErrorToster = value;
    this.isSuccessToster = value;
    this.tosterMessage = '';
  }

}
